const state = {
  localList: localStorage.getItem('localList') ? JSON.parse(localStorage.getItem('localList')) : '',
  file2PathMap: localStorage.getItem('file2PathMap') ? JSON.parse(localStorage.getItem('file2PathMap')) : '',
  name2PathMap: localStorage.getItem('name2PathMap') ? JSON.parse(localStorage.getItem('name2PathMap')) : '',
  bookMap: localStorage.getItem('bookIds') ? JSON.parse(localStorage.getItem('bookIds')) : '',
  localChange: localStorage.getItem('localChange') || ''
}

const mutations = {
  // reset all
  SMART_TEACHING_SYSTEM_RESET_ALL(state, data) {
    const remove = ['localList', 'file2PathMap', 'name2PathMap', 'bookIds', 'localChange']
    for (const key in state) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        if (remove.indexOf(key) > -1) {
          state[key] = data
          localStorage.removeItem(key)
        }
      }
    }
  },
  // localList
  SMART_TEACHING_SYSTEM_OFFLINE_LOCAL_LIST(state, data) {
    state.localList = data
    data === '' ? localStorage.removeItem('localList') : localStorage.setItem('localList', JSON.stringify(data))
  },
  // file2PathMap
  SMART_TEACHING_SYSTEM_OFFLINE_FILE_2_PATH_MAP(state, data) {
    state.file2PathMap = data
    data === '' ? localStorage.removeItem('file2PathMap') : localStorage.setItem('file2PathMap', JSON.stringify(data))
  },
  // name2PathMap
  SMART_TEACHING_SYSTEM_OFFLINE_NAME_2_PATH_MAP(state, data) {
    state.name2PathMap = data
    data === '' ? localStorage.removeItem('name2PathMap') : localStorage.setItem('name2PathMap', JSON.stringify(data))
  },
  // bookMap
  SMART_TEACHING_SYSTEM_OFFLINE_BOOK_MAP(state, data) {
    state.bookMap = data
    data === '' ? localStorage.removeItem('bookMap') : localStorage.setItem('bookMap', JSON.stringify(data))
  },
  // localChange
  SMART_TEACHING_SYSTEM_OFFLINE_LOCAL_CHANGE(state, data) {
    state.localChange = data
    data === '' ? localStorage.removeItem('localChange') : localStorage.setItem('localChange', data)
  }
}

const actions = {
  // 清除所有信息
  resetAll({ commit }) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_RESET_ALL', '')
      resolve()
    })
  },
  // 设置本地资源目录
  setOfflineInfo({ commit }, data) {
    return new Promise(resolve => {
      const { list, file2PathMap, name2PathMap, bookMap } = data
      commit('SMART_TEACHING_SYSTEM_OFFLINE_LOCAL_LIST', list)
      commit('SMART_TEACHING_SYSTEM_OFFLINE_FILE_2_PATH_MAP', file2PathMap)
      commit('SMART_TEACHING_SYSTEM_OFFLINE_NAME_2_PATH_MAP', name2PathMap)
      commit('SMART_TEACHING_SYSTEM_OFFLINE_BOOK_MAP', bookMap)
      resolve(data)
    })
  },
  // 设置书籍id数组
  setLocalList({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_OFFLINE_LOCAL_LIST', data)
      resolve(data)
    })
  },
  // 设置文件-路径映射
  setFile2PathMap({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_OFFLINE_FILE_2_PATH_MAP', data)
      resolve(data)
    })
  },
  // 设置目录-路径映射
  setName2PathMap({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_OFFLINE_NAME_2_PATH_MAP', data)
      resolve(data)
    })
  },
  // 设置目录-路径映射
  setBookMap({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_OFFLINE_BOOK_MAP', data)
      resolve(data)
    })
  },
  // 设置本地资源是否变更过--状态
  setlocalChange({ commit }, data) {
    return new Promise(resolve => {
      commit('SMART_TEACHING_SYSTEM_OFFLINE_LOCAL_CHANGE', data)
      resolve(data)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
